import { render } from "./Pemenuhan.vue?vue&type=template&id=b1063b88"
import script from "./Pemenuhan.vue?vue&type=script&lang=js"
export * from "./Pemenuhan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__